import { Pipe, PipeTransform } from '@angular/core';
import { UserItem } from '../../api/models';

@Pipe({
  name: 'printUserName',
})
export class PrintUserNamePipe implements PipeTransform {
  transform(value: UserItem, ...args: unknown[]): string {
    if (value.page_name) {
      return value.page_name;
    }
    if (value.name && value.last_name && !value.related_registry?.name) {
      return `${value.name} ${value.last_name}`;
    }
    if (
      (value.related_registry?.name && !value.name && !value.last_name) ||
      (value.name && value.last_name && value.related_registry?.name)
    ) {
      return value.related_registry.name;
    }
    return value.email.replace(/([.@])/g, '​$1');
    // return `<span class="email-small">${value.email}</span>`;
  }
}
